// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { shieldXmark16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-shield-xmark': IconShieldXmark;
    }
}

/**
 * The icon component for the 'shieldXmark' icon
 */
export class IconShieldXmark extends Icon {
    public constructor() {
        super(shieldXmark16X16);
    }
}

registerIcon('icon-shield-xmark', IconShieldXmark);
export const iconShieldXmarkTag = 'nimble-icon-shield-xmark';
